import { render, staticRenderFns } from "./TareasActividades.vue?vue&type=template&id=f198aa42&"
import script from "./TareasActividades.vue?vue&type=script&lang=js&"
export * from "./TareasActividades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports